import { render, staticRenderFns } from "./shopSignedlogisticsInfo.vue?vue&type=template&id=c5725d76&scoped=true"
import script from "./shopSignedlogisticsInfo.vue?vue&type=script&lang=js"
export * from "./shopSignedlogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./shopSignedlogisticsInfo.vue?vue&type=style&index=0&id=c5725d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5725d76",
  null
  
)

export default component.exports